import React, { useState } from 'react'
import { website_name, youtube_id } from '../../constants/themeConstants'
import { CgMenuLeftAlt } from "react-icons/cg";
import { Drawer } from 'antd'
import SideBar from './SideBar';
import { Churchlogo } from '../../constants/imageConstants';
import { useNavigate } from 'react-router-dom';


function Navbar() {
 const [menu,setmenu] = useState(false)  

 const navigate = useNavigate()
 
  const menu1 = [
    {name:'Home',path:'/home'},
    {name:'About',path:'/about'},
    {name:'Services',path:'/services'},
    {name:'Contact',path:'/contact_us'},
    {name:'Location',path:'/location'},
  ]

  function openPageLink(path){
   navigate(path)
  }

  function openWebPage(){
    window.open(youtube_id,'_blank')
  }

  return (
    <div className='p-2 border-b h-[60px] border-slate-200 flex items-center justify-between'>
      
        <Drawer 
         rootClassName="custom-drawer"
         closable={false} 
         width={270}
         style={{ padding: 0, margin: 0 }}
         onClose={()=>setmenu(!menu)}
         open={menu} >
            <SideBar closeMenu={()=>setmenu(!menu)} />
        </Drawer>
        
        <div onClick={()=>navigate('/')} className='flex cursor-pointer items-center'>
        <img alt="Churchlogo" className='w-[45px]' src={Churchlogo} />
        <h6 className='hidden text-[13px] md:block font-heading ml-2'>IGPH KAMALANAGAR</h6>
        </div>

        <h6 className='block md:hidden text-[13px] font-heading ml-2'>IGPH KAMALANAGAR</h6>

        <div className='hidden md:block md:flex w-max mr-2 items-center'>
          {menu1?.map((m)=>(
            <h6 onClick={()=>openPageLink(m?.path)} className='text-[15px] w-[70px] text-center font-body px-[10px] py-1 cursor-pointer' key={m?.path}>{m?.name}</h6>
          ))}
          <h6 onClick={openWebPage} className='bg-[#7b026b] text-[12px] rounded cursor-pointer px-4 py-1 mx-2 text-white font-heading'>Join Us</h6>
        </div>
        
        <CgMenuLeftAlt className='block md:hidden bg-[#7b026b] text-white p-1 rounded' size={24} onClick={()=>setmenu(!menu)} />
    </div>
  )
}

export default Navbar